import ErrorBox from '@components/common/ErrorBox';
import Button from '@ui/button/Button';
import DwFormField from '@ui/formfield/DwFormField';
import DwFormFieldPhoneWithPrefix from '@ui/formfield/DwFormFieldPhoneWithPrefix';
import FormField from '@ui/formfield/FormField';
import analytics from '@utils/analytics';
import api from '@utils/api';
import formutils from '@utils/formutils';
import classNames from 'classnames';
// import { getFirstFocusable } from 'src/scripts/utilities/focusableElementUtils';
import createDecorator from 'final-form-focus';
import React, { useEffect, useRef, useState } from 'react';
import { Form } from 'react-final-form';
import ReCAPTCHA from 'react-google-recaptcha';
import { useTranslation } from 'react-i18next';
import NewsletterSection from '../account/NewsletterSection';
import ProfileNameFields from '../account/ProfileNameFields';
import LoginOrRegisterSocial from './LoginOrRegisterSocial';
import customEventBus from '@common/scripts/libs/eventBus';
const focusOnError = createDecorator(); // must be outside the component
const RegisterForm = (props) => {
    const { t } = useTranslation();
    const [formdef, setFormdef] = useState();
    const [initialValues, setInitialValues] = useState();
    const [errors, setErrors] = useState([]);
    const [requiredMarketingConsent, setRequiredMarketingConsent] = useState([]);
    const registerFormRef = useRef(null);
    const [allChannelsChecked, setAllChannelsChecked] = useState(false);
    const [linkCopied, setLinkCopied] = useState(false);
    const [emailSent, setEmailSent] = useState(false);
    const [linkRegister, setLinkRegister] = useState();
    const reCaptchaRef = useRef();
    const showRecaptcha = window.recapchaCfg && JSON.parse(window.recapchaCfg).registerButton;
    const params = new URLSearchParams(window.location.search);
    useEffect(() => {
        let val = {};
        api.getForm('profile', val).then((data) => {
            if (!props.app) {
                //  mandatory on FE
                // data.day.mandatory = true;
                // data.month.mandatory = true;
                // data.year.mandatory = true;
                val.webVer = '12.0';
                val.useSingleField = 'true';
                data.dateofbirthfull.mandatory = true;
                data.personalinforadio.mandatory = true;
                data.trackingbrowsingradio.mandatory = true;
            }
            if (params.get('orderNumber')) {
                api
                    .getOrderDetail(params.get('orderNumber'), params.get('token'))
                    .then((orderData) => {
                    //@ts-ignore
                    const shippingAddress = (orderData === null || orderData === void 0 ? void 0 : orderData.shipping.length) ? orderData === null || orderData === void 0 ? void 0 : orderData.shipping[0].shippingAddress : {};
                    val.title = shippingAddress.title;
                    val.firstname = shippingAddress.firstName;
                    val.lastname = shippingAddress.lastName;
                    val.phone = shippingAddress.phone;
                    val.email = orderData === null || orderData === void 0 ? void 0 : orderData.orderEmail;
                    val.phonePrefix = shippingAddress.phonePrefix;
                    setInitialValues(val);
                    setFormdef(data);
                })
                    .catch(() => {
                    setInitialValues(val);
                    setFormdef(data);
                });
            }
            else if (window.customerData && window.customerEmail) {
                api
                    .CustomerExistByEmail(props.loginEmail)
                    .then((customer) => {
                    val.title = customer.title;
                    val.email = customer.email;
                    val.firstname = customer.firstName;
                    val.lastname = customer.lastName;
                    val.phone = customer.phone;
                    val.phonePrefix = customer.phonePrefix;
                    val.title = customer === null || customer === void 0 ? void 0 : customer.title;
                    //Valorizzo il field Date-Birthday e metto lo 0 davanti a quelli < 9
                    let monthRight = Number(customer.month + 1);
                    let month = monthRight.toString().padStart(2, '0');
                    let day = customer.day.toString().padStart(2, '0');
                    val.localname = customer === null || customer === void 0 ? void 0 : customer.localName;
                    val.localsurname = customer === null || customer === void 0 ? void 0 : customer.localSurname;
                    let gender = (customer === null || customer === void 0 ? void 0 : customer.gender) == t('label.input.gender.male')
                        ? '1'
                        : (customer === null || customer === void 0 ? void 0 : customer.gender) == t('label.input.gender.female')
                            ? '2'
                            : (customer === null || customer === void 0 ? void 0 : customer.gender) == t('label.input.gender.other')
                                ? '3'
                                : (customer === null || customer === void 0 ? void 0 : customer.gender) == t('label.input.gender.prefernottosay')
                                    ? '0'
                                    : '';
                    val.gender = gender ? gender : '0';
                    val.dateofbirthfull = customer.year + '-' + month + '-' + day;
                    setInitialValues(val);
                    setFormdef(data);
                })
                    .catch(() => {
                    setInitialValues(val);
                    setFormdef(data);
                });
            }
            else {
                if (params.get('email')) {
                    val.email = params.get('email');
                }
                if (props.loginEmail) {
                    val.email = props.loginEmail;
                }
                if (props.firstName && props.lastName && props.inContactUs) {
                    val.firstname = props.firstName;
                    val.lastname = props.lastName;
                    val.phone = props.phone;
                    val.phonePrefix = props.phonePrefix;
                    if (props.localName && props.localSurname) {
                        val.localname = props.localName;
                        val.localsurname = props.localSurname;
                    }
                }
                setInitialValues(val);
                setFormdef(data);
            }
        });
    }, []);
    const onSubmit = async (values) => {
        setErrors([]);
        if (window.clickfromstore) {
            values.isClickFromStore = 'clickFromStore';
            if (emailSent) {
                values.sendEmail = true;
            }
        }
        if (showRecaptcha) {
            const token = await reCaptchaRef.current.executeAsync();
            values.gr3Token = token;
        }
        if (values.personalinforadio && window.country === 'US') {
            if (!values.smsChannel && !values.emailChannel && !values.letterChannel && !values.phoneChannel) {
                setRequiredMarketingConsent([t('error.consentmarketing')]);
                let inputMarketing = document.querySelector('.marketing-radio');
                if (inputMarketing) {
                    inputMarketing.focus();
                    return;
                }
            }
        }
        if (props.pageContext) {
            values.pageContext = props.pageContext;
        }
        let errors = await validate(values);
        if (errors && Object.keys(errors).length > 0) {
            return errors;
        }
        if (params.get('destination')) {
            values.destination = params.get('destination');
        }
        let newsletterSelection = '';
        if (values.personalinfo) {
            if (values.addtoemaillistchildren) {
                newsletterSelection += newsletterSelection != '' ? '_children' : 'children';
            }
            if (values.addtoemaillistmen) {
                newsletterSelection += newsletterSelection != '' ? '_men' : 'men';
            }
            if (values.addtoemaillistwomen) {
                newsletterSelection += newsletterSelection != '' ? '_women' : 'women';
            }
            if (values.addtoemaillistgrenoble) {
                newsletterSelection += newsletterSelection != '' ? '_grenoble' : 'grenoble';
            }
            if (values.addtoemaillistgenius) {
                newsletterSelection += newsletterSelection != '' ? '_genius' : 'genius';
            }
        }
        const redirectAfterSuccess = new URLSearchParams(window.location.search).get('redirectToPdp');
        if (window.clickfromstore && !linkRegister) {
            return api
                .loginOnBehalfRegistration(values, formdef)
                .then((data) => {
                if (data.error) {
                    if (data.error.length > 0) {
                        setErrors(data.error);
                    }
                    else {
                        setErrors([data.message]);
                    }
                }
                if (!formutils.checkValidationAfterSubmit(data, errors)) {
                    return errors;
                }
                if (data.success) {
                    setLinkRegister(data.subscriptionLink);
                    if (linkCopied) {
                        if (data.subscriptionLink) {
                            navigator.clipboard.writeText(data.subscriptionLink);
                        }
                    }
                }
            })
                .catch((e) => setErrors([e]));
        }
        else {
            return api
                .register(values, formdef, redirectAfterSuccess)
                .then((data) => {
                var _a;
                if (data.error) {
                    if (data.error.length > 0) {
                        setErrors(data.error);
                    }
                    else {
                        setErrors([data.message]);
                    }
                }
                if (!formutils.checkValidationAfterSubmit(data, errors)) {
                    return errors;
                }
                if (newsletterSelection != '')
                    analytics.createAccountNl(newsletterSelection);
                initialValues.authenticationProviderID ? analytics.createAccountThree(initialValues.authenticationProviderID) : analytics.createAccountTwo();
                if (data.success) {
                    // analytics.wishlistInteractionComplete('registration');
                    if (props.fromPage || props.inContactUs) {
                        window.location.replace(data.redirectUrl);
                    }
                    else {
                        props.setLoginStep('registration-successful');
                        if (props.reloadComponent) {
                            window.loggedin = true;
                            customEventBus.emit('account:update', { firstName: (_a = data.customer) === null || _a === void 0 ? void 0 : _a.firstName });
                        }
                        props.setForceReload(true);
                    }
                }
            })
                .catch((e) => setErrors([e]));
        }
    };
    const validate = async (values) => {
        if (window.customerData && window.customerEmail && window.profiletoken) {
            values.profiletoken = window.profiletoken;
        }
        return await formutils.validateForm(values, formdef, 'profile');
    };
    const turnOnOrOffChannels = (value, mutator) => {
        mutator({
            smsChannel: value,
            emailChannel: value,
            phoneChannel: value,
            letterChannel: value,
        });
    };
    // const appleSigninRegister = (values: models.RegisterForm) => {
    //   setInitialValues(values);
    // };
    const readOnlyEmail = (initialValues === null || initialValues === void 0 ? void 0 : initialValues.authenticationProviderID) === 'Line' && !(initialValues === null || initialValues === void 0 ? void 0 : initialValues.email) ? false : !!(initialValues === null || initialValues === void 0 ? void 0 : initialValues.authenticationProviderID) || Boolean(props.loginEmail);
    // const readOnlyPhone = initialValues?.authenticationProviderID === 'Line' && initialValues?.phone TODO: before implement, verify how phone info arrives from Line (with phonePrefix or not)
    if (!formdef) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: classNames('register_form', { 'register-click-from-store': window.clickfromstore }) },
        initialValues.authenticationProviderID ? (React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col-md-8 col-sm-9" },
                React.createElement("p", { className: "register_form__subtitle primary-xs" }, t('register.completesocial'))))) : (React.createElement(React.Fragment, null,
            !props.inContactUs && React.createElement("p", { className: "register_form__subtitle primary-xs" }, t('register.subtitle')),
            window.sociallogin && !window.clickfromstore && (React.createElement(React.Fragment, null,
                React.createElement("h3", { className: "form-section-title faster-social primary-s" }, t('login.fastersocial')),
                React.createElement(LoginOrRegisterSocial, { register: true }))))),
        !window.clickfromstore && React.createElement("div", { className: "mt-24 mb-24 border-top" }),
        React.createElement(Form, { onSubmit: onSubmit, initialValues: initialValues, validate: validate, mutators: { global: formutils.globalMutator }, decorators: [focusOnError], render: (formprops) => {
                return (React.createElement("form", { ref: registerFormRef, onSubmit: formprops.handleSubmit },
                    React.createElement("div", { className: "form-section" },
                        !props.inContactUs && React.createElement("h3", { className: "form-section-title primary-s" }, t('login.logininfo')),
                        React.createElement("div", { className: 'register_form__email' + (props.setLoginStep && readOnlyEmail ? '-row' : '') },
                            React.createElement("div", { className: classNames('register_form__input-column', { 'full-width': window.customerData && window.customerEmail }) },
                                React.createElement(DwFormField, { def: formdef, name: "email", readonly: readOnlyEmail, disabled: readOnlyEmail, autocomplete: "email", validTick: true })),
                            props.setLoginStep && readOnlyEmail && !window.customerData && !window.customerEmail && (React.createElement("div", { className: "register_form__edit-column" },
                                React.createElement("button", { type: "button", onClick: () => props.setLoginStep('email'), className: "link" }, t('login.editemail'))))),
                        !window.clickfromstore && !initialValues.authenticationProviderID && (React.createElement("div", { className: "password" },
                            React.createElement(DwFormField, { def: formdef, name: "password", type: "password", helperText: t('register.passwordcriteria'), showPassword: true, autocomplete: "new-password", validTick: true, requiredLabel: !initialValues.authenticationProviderID })))),
                    React.createElement("div", { className: "form-section" },
                        !props.inContactUs && (React.createElement(React.Fragment, null,
                            React.createElement("h3", { className: "form-section-title primary-s" }, t('profile.personalinformation')),
                            React.createElement(ProfileNameFields, { formdef: formdef, isRegisterForm: true }))),
                        React.createElement(DwFormField, { def: formdef, name: "dateofbirthfull", type: "date", autocomplete: "date-of-brith", helperText: t('profile.birthdaymessage'), maxDate: "9999-12-31" }),
                        React.createElement(DwFormField, { def: formdef, name: "gender", type: "radio", groupClassName: "form-group--gender-radio" }),
                        !props.phone && !props.phonePrefix && React.createElement(DwFormFieldPhoneWithPrefix, { def: formdef, uniqueLabel: t('profile.phonenumber') })),
                    !window.clickfromstore && (React.createElement(React.Fragment, null,
                        React.createElement("div", { className: "form-section" },
                            React.createElement("h3", { className: "form-section-title primary-s" }, t('login.marketingtitle')),
                            React.createElement("div", { className: "flag wrapper-flag" },
                                React.createElement(DwFormField, { def: formdef, type: "radio", name: "personalinforadio", onChange: (e) => {
                                        // console.info(e);
                                        if (window.country == 'US' && e.target.value == '0') {
                                            turnOnOrOffChannels(false, formprops.form.mutators.global);
                                            setAllChannelsChecked(false);
                                        }
                                        else if (window.country != 'US') {
                                            turnOnOrOffChannels(e.target.value == '1', formprops.form.mutators.global);
                                        }
                                    }, groupClassName: "form-group--gender-radio" })),
                            formprops.values.personalinforadio == '1' && (React.createElement(React.Fragment, null,
                                React.createElement(NewsletterSection, { formdef: formdef, formInstance: formprops.form }),
                                window.country == 'US' && (React.createElement("div", { className: "register_form__comunication-channels" },
                                    React.createElement("p", { className: "register_form__info-label mt-24 primary-xs" },
                                        t('register.newsletterconditions'),
                                        " "),
                                    React.createElement(FormField, { className: "marketing-radio", type: "checkbox", name: "allChannels", controlledInput: true, checkboxChecked: allChannelsChecked, label: t('label.all'), onChange: (e) => {
                                            setAllChannelsChecked(e.target.checked);
                                            turnOnOrOffChannels(e.target.checked, formprops.form.mutators.global);
                                            setRequiredMarketingConsent([]);
                                        } }),
                                    React.createElement("div", { className: "channel-flags newsletter-flag" },
                                        React.createElement(DwFormField, { def: formdef, onChange: (e) => setRequiredMarketingConsent([]), name: "emailChannel", type: "checkbox" }),
                                        React.createElement(DwFormField, { def: formdef, onChange: (e) => setRequiredMarketingConsent([]), name: "smsChannel", type: "checkbox" }),
                                        React.createElement(DwFormField, { def: formdef, onChange: (e) => setRequiredMarketingConsent([]), name: "phoneChannel", type: "checkbox" }),
                                        React.createElement(DwFormField, { def: formdef, onChange: (e) => setRequiredMarketingConsent([]), name: "letterChannel", type: "checkbox" })),
                                    React.createElement(ErrorBox, { errors: requiredMarketingConsent })))))),
                        React.createElement("div", { className: "form-section" },
                            React.createElement("h3", { className: "form-section-title primary-s" }, t('login.trackingbrowsingtitle')),
                            React.createElement("div", { className: "wrapper-flag" },
                                React.createElement(DwFormField, { def: formdef, type: "radio", name: "trackingbrowsingradio", groupClassName: "form-group--gender-radio mb-24" }))),
                        React.createElement(DwFormField, { def: formdef, type: "checkbox", name: "termsandconditions", requiredLabel: true }))),
                    React.createElement("div", { className: "register_form__label" },
                        React.createElement("p", { className: "primary-xs" }, t('label.mandatoryfields'))),
                    React.createElement(ErrorBox, { errors: errors }),
                    React.createElement("div", { className: "row row-reverse-mobile" },
                        React.createElement("div", { className: "col-md-6" }, !window.clickfromstore ? (React.createElement(React.Fragment, null, !props.inContactUs && (React.createElement(React.Fragment, null, props.setLoginStep ? (React.createElement("button", { type: "button", onClick: props.onBack, className: "button button--tertiary button--arrow-left min-24" }, t('button.back'))) : (React.createElement("a", { href: window.loginUrl, className: "button button--tertiary button--arrow-left min-24" }, t('label.login'))))))) : (React.createElement("button", { type: "submit", onClick: (e) => {
                                setLinkCopied(true);
                                if (linkRegister) {
                                    navigator.clipboard.writeText(linkRegister);
                                    e.preventDefault();
                                }
                                setTimeout(() => {
                                    setLinkCopied(false);
                                }, 3000);
                            }, className: linkCopied ? 'button button--primary' : 'button button--secondary' }, linkCopied ? t('button.copiedlink') : t('button.copylink')))),
                        React.createElement("div", { className: "col-md-6" },
                            React.createElement(Button, { type: "submit", disabled: formprops.submitting, onClick: (e) => {
                                    setEmailSent(true);
                                    if (linkRegister) {
                                        api.sendLoginOnBehalfRegistrationEmail(props.loginEmail, linkRegister);
                                        e.preventDefault();
                                    }
                                    setTimeout(() => {
                                        setEmailSent(false);
                                    }, 3000);
                                }, cls: [emailSent ? 'button--secondary' : 'button--primary'] }, window.clickfromstore ? (emailSent ? t('button.sentsubscriptionemail') : t('button.sendsubscriptionemail')) : t('button.createaccount.registration')))),
                    showRecaptcha && React.createElement(ReCAPTCHA, { className: "recaptcha", sitekey: window.atob(window.recapchaData), size: "invisible", ref: reCaptchaRef })));
            } })));
};
export default RegisterForm;
